<template>
  <div class="userAirNotifications">
    <b-message v-if="$globals.ticketAirlines.length > 0" :style="customStyle" type="is-info">
      <strong>Heads up!</strong> {{ unusedTicketsMessage() }}
    </b-message>
  </div>
</template>

<script>
export default {
  name: "UserAirNotifications",
  props: {
    customStyle:{}
  },
  data(){
    return{
    };
  },
  methods: {
    unusedTicketsMessage() {
      let message = 'Unused tickets are available for ';
      let airline;
      let first = true;
      if (this.$globals.ticketAirlines.length > 0){
        for (airline of this.$globals.ticketAirlines) {
          if (first) {
            message += this.$globals.vendors.airlines[airline]
            first = false
            continue;
          }
          message += ', ' + this.$globals.vendors.airlines[airline]
        }
      }
      //message += ' and ' + this.$globals.vendors.airlines[this.$globals.ticketAirlines[this.$globals.ticketAirlines.length - 1]]

      return message;
    },
  },
}
</script>

<style lang="scss" scoped>

</style>